import api from '.'
import { Programs, ProgramSelectionReq } from './programs.types'

// Query Key factory
export const ProgramsKeys = {
	all: ['programs'],
	basketPrograms: (marketBasketId: Id, similarProductId: Id) => [
		...ProgramsKeys.all,
		marketBasketId,
		similarProductId,
	],
}

const ProgramsApi = {
	basketPrograms: (marketBasketId: Id, similarProductId: Id) =>
		api
			.get<
				APIRes<Programs>
			>(`/programs?marketBasketId=${marketBasketId}&similarProductId=${similarProductId}`)
			.then((res) => res.data.data),

	selectProgram: (query: ProgramSelectionReq) =>
		api.post('/programs/select', null, {
			params: query,
		}),
}

export default ProgramsApi
